import { Option } from '@/modules/entity/utils/option.ts';

export const titleOptions: Option<string>[] = [
  {
    label: 'Mr.',
    value: 'mr.',
  },
  {
    label: 'Mrs.',
    value: 'mrs.',
  },
  {
    label: 'Miss',
    value: 'miss',
  },
  {
    label: 'Ms.',
    value: 'ms.',
  },
  {
    label: 'Dr.',
    value: 'dr.',
  },
  {
    label: 'Prof.',
    value: 'prof.',
  },
  {
    label: 'Sir',
    value: 'sir',
  },
  {
    label: 'Lady',
    value: 'lady',
  },
];
